import { PopupOptionsSetter } from "src/ts";
import { useSetPopup } from "../use-popup";
import { GlobalService } from "../../../hexagonal-architecture-frontend-base/src/domain/services/Global.service";

import { useTranslation } from "react-i18next";

export const useShowConfirmCall = () => {
    const { t } = useTranslation();
    const { openPopup, closePopup } = useSetPopup();

    const showConfirmCallPopup = (onClose?: () => void) => {
        const confirmCallPopupOptions: PopupOptionsSetter = {
            title: GlobalService.uppercaseAfterPointFirstsLetters(
                t("pages.informeDetallado.modalConfirmCall.title")
            ),
            children: (
                <>
                    <p>
                        {GlobalService.uppercaseAfterPointFirstsLetters(
                            t("pages.informeDetallado.modalConfirmCall.text")
                        )}
                    </p>
                </>
            ),
            buttons: [
                {
                    styleType: "primary",
                    children: GlobalService.uppercaseFirstLetter(
                        t("pages.informeDetallado.modalConfirmCall.confirmBtn")
                    ),
                    onClick: () => {
                        closePopup();
                        if (onClose) onClose();
                    },
                },
            ],
        };

        openPopup(confirmCallPopupOptions);
    };

    return { showConfirmCallPopup };
};
